<script setup lang="ts">
import { trackWizardEvent, wizardStepName } from '~/utils/wizardAnalytics'

const { step, submitted, hydrate } = useOfferteWizard()

useHead({
  title: 'Offerte aanvragen — Wizard | Pro-Air',
  meta: [
    { name: 'description', content: 'Stel in 5 stappen je airco-offerte samen. Volledig vrijblijvend.' },
  ],
})

onMounted(() => {
  hydrate()
  if (submitted.value) return
  trackWizardEvent(step.value === 1 ? 'wizard_start' : 'wizard_resume', {
    step_number: step.value,
    step_name: wizardStepName(step.value),
  })
  trackWizardEvent('wizard_step_view', {
    step_number: step.value,
    step_name: wizardStepName(step.value),
    direction: 'initial',
  })
})
</script>

<template>
  <section class="pa-wizard">
    <div class="pa-container">
      <div class="pa-wizard__inner">
        <div class="pa-wizard__intro">
          <span class="pa-wizard__intro-eyebrow">Offerte aanvragen</span>
          <h1 class="pa-wizard__intro-title">Stel in 5 stappen je offerte samen</h1>
          <p class="pa-wizard__intro-text">Volledig vrijblijvend. Binnen 2 werkdagen ontvang je een persoonlijke prijsopgave op maat.</p>
        </div>

        <WizardStepper v-if="!submitted" />

        <div class="pa-wizard__card">
          <WizardSuccess v-if="submitted" />
          <template v-else>
            <WizardStepPackage v-if="step === 1" />
            <WizardStepDetails v-else-if="step === 2" />
            <WizardStepRooms v-else-if="step === 3" />
            <WizardStepPlanning v-else-if="step === 4" />
            <WizardStepSummary v-else-if="step === 5" />
            <WizardNav />
          </template>
        </div>

        <div v-if="!submitted" class="pa-wizard__help">
          Liever telefonisch? Bel <a href="tel:0318636810">0318-636810</a> — ma–vr 8:00–17:00 uur.
        </div>
      </div>
    </div>
  </section>
</template>
